import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// layouts
import CompactLayout from 'src/layouts/compact';
// auth
import { lazyRetry } from 'src/utils/lazyRetry';

// ----------------------------------------------------------------------

const Page500 = lazyRetry(() => import('src/pages/500'));
const Page404 = lazyRetry(() => import('src/pages/404'));
const PrivacyPolicyPage = lazyRetry(() => import('src/pages/Privacy'));
const TermsAndConditionsPage = lazyRetry(() => import('src/pages/Terms'));
const MaintenancePage = lazyRetry(() => import('src/pages/Maintenance'));

// ----------------------------------------------------------------------
// ----------------------------------------------------------------------

export const getMainRoutes = () => {
  return [
    {
      element: (
        <CompactLayout>
          <Suspense fallback={null}>
            <Outlet />
          </Suspense>
        </CompactLayout>
      ),
      children: [
        { path: '500', element: <Page500 /> },
        { path: '404', element: <Page404 /> },
      ],
    },
    {
      path: 'maintenance',
      element: <MaintenancePage />,
    },
    {
      path: 'privacy',
      element: <PrivacyPolicyPage />,
    },
    {
      path: 'terms',
      element: <TermsAndConditionsPage />,
    },
    {
      path: '*',
      element: <Page404 />,
    },
  ];
};
